<template>
  <div class="dropzone" @dragenter="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop="drop"
       :class="{ dragItem : isDrag }">
    <div class="container">
      <div class="box box1">Arrastrar y soltar imagenes</div>
      <div class="box box3">o</div>
      <div class="box box2">
        <button type="button" class="btn btn-warning btn-micro" @click="seleccionarArchivos">
          <i class="fa fa-cloud-upload">
          </i> Agregar Archivos
        </button>
      </div>
    </div>
    <input @change="drop" hidden ref="file" id="file" type="file" class="files" multiple>
    <div class="thumb">
      <div v-if="isLoading">Cargando imagenes...</div>
      <div v-else v-for="(item, index) in files" class="img">
        <div class="src">
          <img :src="cargaImagen(item)" @click="modal(item)" alt="img">
          <i class="eliminar fa fa-trash" @click="removeImage(item, index)"></i>
        </div>
      </div>
    </div>
    <div v-if="files.length >= 2" @click="removeAll"
         class="delete-all pointer bg-danger w-100 h-30 mt-2 mb-2 text-center">
      <small>Eliminar Todo <i style="font-size: 12px" class="fa fa-close"></i></small>
    </div>
    <vuestic-alert class="alerta" :with-close-btn="true" v-if="error" type="danger">
      {{error}}
    </vuestic-alert>
    <vuestic-modal ref="staticModal" :force="false">
      <div slot="title">{{name}}</div>
      <img class="imgModal" :src="cargaImagen(img)">
    </vuestic-modal>
  </div>
</template>

<script>
  import VuesticAlert from "../../../vuestic-theme/vuestic-components/vuestic-alert/VuesticAlert";
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import {URL_SERVER} from "../../../api/config";
  import {uuid} from "vue-uuid";

  export default {
    name: "filesDragNDrop",
    components: {VuesticModal, VuesticAlert},
    computed: {
      files() {
        return this.$store.state.producto.producto.imagenes
      }
    },
    data() {
      return {
        isDrag: false,
        error: null,
        isLoading: false,
        img: '',
        name: '',
        imagenes: [],
      }
    },
    methods: {
      cargaImagen(string) {
        return string;
      },
      sendImageToServer(imagenes) {
        console.log(imagenes[0], "sendImagenes")
        this.isLoading = true
        this.$axios.put(`productos/producto/${this.$store.state.producto.producto.id}/imagen`, {
          imagenes
        }).then(response => {
          if (response.status === 204) {
            this.$store.dispatch("producto/getImages", {field: "id", value: this.$store.state.producto.producto.id})
            this.isLoading = false
          } else {
            this.$swal("Error", "error", "error")
            this.isLoading = false
          }
        }).catch(error => {
          this.isLoading = false
          console.error(error)
          this.$swal("Error", error, "error")
        })
      },
      dragEnter() {
        this.isDrag = true
      },
      dragLeave() {
        this.isDrag = false
      },
      drop(e) {
        e.preventDefault()
        this.isDrag = false
        if (this.imagenes.length >= 4) {
          this.$swal('Error!', 'No se pueden agregar más imagenes', 'error')
        } else {
          const files = e.dataTransfer !== undefined ? e.dataTransfer.files : e.target.files
          let readers = []
          Array.from(files).forEach(item => {
            if (!item.type.match('image/jpeg')) {
              setTimeout(() => this.error = "", 500)
              this.error = 'Solo se aceptan imagenes .jpeg';
              return
            }
            readers.push(this.readFile(item))
          })
          Promise.all(readers).then(items => {
            const images = items.map(i => ({imagen: i, id: uuid.v4()}))
            this.sendImageToServer(images)
          })
        }
      },
      readFile(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = function () {
            resolve(reader.result);
          }
          reader.onerror = function (e) {
            reject(e);
          }
          reader.readAsDataURL(file)
        });
      },
      seleccionarArchivos() {
        this.$refs.file.dispatchEvent(new MouseEvent('click'))
      },
      removeImage(item, index) {
        let image = {id: item.replace(".jpeg", "")}
        this.$axios.delete(`productos/producto/${this.$store.state.producto.producto.id}/imagen`, {
          data: {
            imagenes: [image]
          }
        }).then(response => {
          if (response.status === 204) {
            this.$store.commit("producto/DELETE_IMAGE", index)
            this.$swal("Correcto!!", "Imagen Eliminada Correctamente...", "success")
          }
        }).catch(console.error)
      },
      removeAll() {
        let images = this.$store.state.producto.producto.imagenes.map(item => {
          const id = item.replace(".jpeg", "")
          return {id}
        })
        this.$axios.delete(`productos/producto/${this.$store.state.producto.producto.id}/imagen`, {
          data: {
            imagenes: images
          }
        }).then(response => {
          if (response.status === 204) {
            this.$swal("Correcto", "Imagenes Eliminadas Correctamente...", "success")
            this.$store.commit("producto/SET_IMAGENES", [])
          } else this.$swal("Error", response, "error")
        }).catch(console.error)
      },
      modal(item) {
        this.img = item
        console.log(item)
        this.$refs.staticModal.open()
      }
    }
  }
</script>

<style scoped lang="scss">
  .alerta {
    margin-top: 20px;
  }

  .delete-all {
    transition: all linear 200ms;
    color: white;
    border-radius: 7px;

    &:hover {
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.75);
    }
  }

  .imgModal {
    width: 100%;
    border-radius: 10px;
  }

  .dropzone {
    align-items: center;
    width: 80%;
    min-height: 200px;
    background: #dddddd;
    border-radius: 5px;
    margin-left: 10%;
    padding: 20px;
    display: inline-block;
  }

  .dragItem {
    background: #d1f9c4;
  }

  .thumb {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .src {
    width: 100px;
    flex: 1;
    margin-top: 30px;
    margin-right: 10px;
    position: relative;
    overflow: hidden;
    height: 100px;
    transition: all 300ms ease-in-out;
    transform-origin: left center;
    border-radius: 10px;

  }

  .src > img {
    height: 100%;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  .src:hover {
    transform: scale(1.2);
    cursor: pointer;
    margin-right: 30px;
    /*box-shadow: 0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,0.22);*/
  }

  @media screen and (max-width: 1000px) and (min-width: 500px) {
    div .box1 .box3 {
      display: none;
    }
  }

  .eliminar {
    cursor: pointer;
    position: absolute;
    color: black;
    left: 5px;
    top: 5px;
    background: rgba(255, 255, 210, 0.9);
    /* padding: 9px; */
    padding-top: 3.5px;
    padding-left: 5.5px;
    border-radius: 50%;
    width: 25px;
    display: block !important;
    height: 25px;
  }

  .eliminar:hover {
    color: red
  }

  .container {
    display: grid;
    grid-template-columns:repeat(3, 1fr);
    grid-auto-rows: 2fr;
    grid-gap: 10px;
    align-items: center;
    align-content: center;
  }

  .box {
    font-weight: bold;
  }

  .box1 {
    grid-column: 2/3;
    width: 100%;
    text-align: center;
  }

  .box2 {
    grid-column: 2/3;

    button {
      margin: 0 0 0 20px {
      };
    }
  }

  .box3 {
    grid-column: 2/3;
    text-align: center;
  }
</style>
